'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _objectWithoutProperties=require('@babel/runtime/helpers/objectWithoutProperties'),browserLogs=require('@datadog/browser-logs'),validateLogPayload=require('../utils/validateLogPayload.js');function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var _objectWithoutProperties__default=/*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);var _excluded = ["message"],
    _excluded2 = ["message"],
    _excluded3 = ["message"];
var defaultConfig = {
  disableJWTDecode: false
};

var createLogger = function createLogger(params, config) {
  browserLogs.datadogLogs.init(params);
  return {
    info: function info(payload) {
      var _validateLogPayload = validateLogPayload(payload, config),
          message = _validateLogPayload.message,
          cleanPayload = _objectWithoutProperties__default['default'](_validateLogPayload, _excluded);

      browserLogs.datadogLogs.logger.info(message, cleanPayload); // const { message, ...rest } = payload
      // datadogLogs.logger.info(message, rest);
    },
    warn: function warn(payload) {
      var _validateLogPayload2 = validateLogPayload(payload, config),
          message = _validateLogPayload2.message,
          cleanPayload = _objectWithoutProperties__default['default'](_validateLogPayload2, _excluded2);

      browserLogs.datadogLogs.logger.warn(message, cleanPayload); // datadogLogs.logger.warn(message, rest);
      // const { message, ...rest } = payload
    },
    error: function error(payload) {
      // const { message, ...rest } = payload
      // datadogLogs.logger.error(message, rest);
      var _validateLogPayload3 = validateLogPayload(payload, config),
          message = _validateLogPayload3.message,
          cleanPayload = _objectWithoutProperties__default['default'](_validateLogPayload3, _excluded3);

      browserLogs.datadogLogs.logger.error(message, cleanPayload);
    }
  };
};

var init = function init(_ref) {
  var _window;

  var clientToken = _ref.clientToken,
      _ref$site = _ref.site,
      site = _ref$site === void 0 ? 'datadoghq.com' : _ref$site,
      _ref$forwardErrorsToL = _ref.forwardErrorsToLogs,
      forwardErrorsToLogs = _ref$forwardErrorsToL === void 0 ? true : _ref$forwardErrorsToL,
      _ref$sampleRate = _ref.sampleRate,
      sampleRate = _ref$sampleRate === void 0 ? 100 : _ref$sampleRate,
      _ref$silentMultipleIn = _ref.silentMultipleInit,
      silentMultipleInit = _ref$silentMultipleIn === void 0 ? false : _ref$silentMultipleIn,
      service = _ref.service,
      version = _ref.version,
      env = _ref.env;
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConfig;

  if (!((_window = window) !== null && _window !== void 0 && _window.LOGS)) {
    var mergedConfig = Object.assign({}, defaultConfig, config);
    window.LOGS = createLogger({
      clientToken: clientToken,
      site: site,
      forwardErrorsToLogs: forwardErrorsToLogs,
      sampleRate: sampleRate,
      silentMultipleInit: silentMultipleInit,
      service: service,
      version: version,
      env: env
    }, mergedConfig);
  }
};exports.default=init;exports.init=init;